var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "waba-detail" } },
    [
      _c("AppBreadCrumb", {
        staticClass: "visitor-detail-bread-crumb",
        attrs: {
          paths: [
            { title: _vm.$t("whatsapp_business_api.businessChannelDetail") },
          ],
          select: true,
        },
      }),
      _vm._v(" "),
      _vm.channel
        ? _c(
            "div",
            { staticClass: "route-page-content breadcrumb-content" },
            [
              _c("SidebarChild", {
                attrs: {
                  items: _vm.menuItems,
                  "selected-item": _vm.currentTab,
                  focusActive: true,
                },
                on: {
                  selected: function (i) {
                    return (_vm.currentTab = i.key)
                  },
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "page-content-wrapper" }, [
                _c("div", { staticClass: "toolbar" }, [
                  _c(
                    "div",
                    { staticClass: "left" },
                    [
                      _c(
                        "IconButton",
                        {
                          attrs: {
                            "on-click": function () {
                              return _vm.$router.push("/integrations/waba")
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v(" chevron_left "),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "icon-container" },
                        [_c("WhatsappBusinessIcon")],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "name" }, [
                        _vm._v(
                          _vm._s(_vm.$t("whatsapp_business_api.title")) +
                            " :" +
                            _vm._s(_vm.channel.name)
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "right" },
                    [
                      _c(
                        "a-button",
                        {
                          attrs: { type: "primary", loading: _vm.loading },
                          on: {
                            click: function ($event) {
                              _vm.visible = true
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("wp.startChatWithAnyNo")) +
                              "\n                        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.canRegisterPhoneToolbar
                        ? _c(
                            "a-button",
                            {
                              attrs: { disabled: _vm.registerPhoneLoading },
                              on: { click: _vm.registerPhoneDebug },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.registerPhoneLoading
                                      ? _vm.$t("whatsapp.registerPhoneLoading")
                                      : _vm.$t("whatsapp.registerPhoneButton")
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _vm.currentTab === "profile"
                  ? _c(
                      "div",
                      [
                        _c("BusinessProfile", {
                          model: {
                            value: _vm.channel,
                            callback: function ($$v) {
                              _vm.channel = $$v
                            },
                            expression: "channel",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentTab === "detail"
                  ? _c(
                      "div",
                      [
                        _c("UpdateDetail", {
                          on: { refresh: _vm.refreshChannel },
                          model: {
                            value: _vm.channel,
                            callback: function ($$v) {
                              _vm.channel = $$v
                            },
                            expression: "channel",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentTab === "visibility"
                  ? _c(
                      "div",
                      [
                        _c("Visibility", {
                          model: {
                            value: _vm.channel,
                            callback: function ($$v) {
                              _vm.channel = $$v
                            },
                            expression: "channel",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentTab === "templates"
                  ? _c(
                      "div",
                      [
                        _c("TemplateMessageList", {
                          attrs: { changePage: _vm.changePage },
                          on: { "edit-template": _vm.handleEditTemplate },
                          model: {
                            value: _vm.channel,
                            callback: function ($$v) {
                              _vm.channel = $$v
                            },
                            expression: "channel",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentTab === "new-template"
                  ? _c(
                      "div",
                      [
                        _c("TemplateMessageForm", {
                          attrs: {
                            channel: _vm.channel,
                            changePage: _vm.changePage,
                            "edit-mode": _vm.editMode,
                            "template-to-edit": _vm.templateToEdit,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentTab === "broadcast-requests"
                  ? _c(
                      "div",
                      [
                        _c("BroadcastRequests", {
                          attrs: {
                            channel: _vm.channel,
                            changePage: _vm.changePage,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentTab === "customer-groups"
                  ? _c(
                      "div",
                      [
                        _c("CustomerGroups", {
                          attrs: {
                            channel: _vm.channel,
                            changePage: _vm.changePage,
                            "channel-id": _vm.channel._id,
                            isBusiness:
                              _vm.channel.type ===
                              "whatsapp-business-api-supsis",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentTab === "wallet"
                  ? _c(
                      "div",
                      { staticStyle: { padding: "10px" } },
                      [_c("Wallet")],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentTab === "voice-configuration"
                  ? _c(
                      "div",
                      [
                        _vm.isVoiceConfigurationEnabled()
                          ? [
                              _c("VoiceConfiguration", {
                                attrs: { changePage: _vm.changePage },
                                model: {
                                  value: _vm.channel,
                                  callback: function ($$v) {
                                    _vm.channel = $$v
                                  },
                                  expression: "channel",
                                },
                              }),
                            ]
                          : [
                              _c(
                                "div",
                                { staticClass: "voice-configuration-disabled" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "disabled-content" },
                                    [
                                      _vm._m(0),
                                      _vm._v(" "),
                                      _c("h3", [
                                        _vm._v("Ses Yapılandırması Devre Dışı"),
                                      ]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "\n                                    Bu özellik şu anda etkin değil. Ses yapılandırması özelliğini kullanmak için\n                                    planınızı yükseltmeniz gerekebilir.\n                                "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "SupsisButton",
                                        {
                                          attrs: { primary: "" },
                                          on: { click: _vm.upgradePlan },
                                        },
                                        [_vm._v("Planı Yükselt")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentTab === "meta-insights"
                  ? _c(
                      "div",
                      [_c("MetaInsights", { attrs: { channel: _vm.channel } })],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentTab === "ad-optimization"
                  ? _c(
                      "div",
                      [
                        _c("WABAAdOptimization", {
                          model: {
                            value: _vm.channel,
                            callback: function ($$v) {
                              _vm.channel = $$v
                            },
                            expression: "channel",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentTab === "comparison"
                  ? _c(
                      "div",
                      { staticStyle: { padding: "20px" } },
                      [_c("WhatsappComparison")],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentTab === "movements"
                  ? _c(
                      "div",
                      { staticClass: "movements-wrapper" },
                      [
                        _c("MovementsPage", {
                          attrs: { channel: _vm.channel },
                          on: { refresh: _vm.refreshChannel },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentTab === "developer"
                  ? _c(
                      "div",
                      [
                        _c("DeveloperSettings", {
                          model: {
                            value: _vm.channel,
                            callback: function ($$v) {
                              _vm.channel = $$v
                            },
                            expression: "channel",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.channel
        ? _c("WhatsappStartChat", {
            attrs: {
              visibleStartChat: _vm.visible,
              "show-alert-message": _vm.showAlertMessage,
              "channel-id": _vm.channel._id,
              channel: _vm.channel,
            },
            on: {
              "modal-closed": function ($event) {
                _vm.visible = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            icon: "exclamation-circle",
            title: _vm.$t("whatsappChannel.whatsappChannel"),
          },
          on: {
            cancel: function ($event) {
              _vm.deleteModal = false
            },
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "a-button",
                    {
                      key: "back",
                      on: {
                        click: function ($event) {
                          _vm.deleteModal = false
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("chatbotv2.dismiss")) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      key: "submit",
                      attrs: { type: "danger" },
                      on: { click: _vm.deleteWhatsappChannel },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("chatbotv2.delete")) +
                          "\n                "
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.deleteModal,
            callback: function ($$v) {
              _vm.deleteModal = $$v
            },
            expression: "deleteModal",
          },
        },
        [
          _c("p", [
            _vm._v(
              _vm._s(_vm.$t("whatsappChannel.deleteWhatsappChannelDescription"))
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon" }, [
      _c("span", { staticClass: "material-icons" }, [_vm._v("mic_off")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }